import {
  useGetProjectFieldDefinitionsLazyQuery,
  useGetShareForShareBuilderLazyQuery,
} from '@frameio/graphql-client/generated';
import { useActiveShareId } from '@frameio/shared/contexts';
import { useHoverIntent } from '@frameio/vapor';

export function usePrefetchForShareBuilder({
  shareId,
  projectId,
}: {
  shareId: string;
  projectId: string;
}) {
  const activeShareId = useActiveShareId();
  const [shareBuilderQuery, { called: calledShare }] =
    useGetShareForShareBuilderLazyQuery({
      variables: { shareId },
      nextFetchPolicy: 'cache-only',
    });
  const [fieldDefinitionsQuery, { called: calledFields }] =
    useGetProjectFieldDefinitionsLazyQuery({
      variables: { projectId },
      nextFetchPolicy: 'cache-only',
    });

  const { bind } = useHoverIntent(() => {
    if (!calledShare && !calledFields && activeShareId !== shareId) {
      fieldDefinitionsQuery();
      shareBuilderQuery();
    }
  });

  return { bind };
}
